let language = {
    STORE_ORDER_DELETE_SUCCESS: "删除店铺零售订单成功",
    STORE_ORDER_DELETE_SUCCESS_CONTENT: "客户订单已成功删除",
    STORE_ORDER_DELETE_FAIL_TITLE: "删除店铺零售订单失败",
    STORE_ORDER_DELETE_FAIL_CONTENT: "该客户订单已合并，无法删除",
    
    STORE_ORDER_DELETE_QUESTION_TITLE: "删除确认",
    STORE_ORDER_DELETE_QUESTION_CONTENT: "您确定要删除此客户订单吗？一旦删除，将无法恢复。",
};

export { language }